import { createContext, useContext, useMemo, useState } from "react";

const FiltersCtx = createContext(null);

function defaultRange() {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 30);
  return { start: start.toISOString(), end: end.toISOString(), label: "Last 30 days" };
}

export function AppFiltersProvider({ children }) {
  const [range, setRange] = useState(defaultRange());
  const [rep, setRep] = useState(null);
  const [source, setSource] = useState(null);
  const value = useMemo(() => ({ range, setRange, rep, setRep, source, setSource }), [range, rep, source]);
  return <FiltersCtx.Provider value={value}>{children}</FiltersCtx.Provider>;
}

export function useAppFilters() {
  return useContext(FiltersCtx);
}
